<template>
  <div class="card border-0 bg-white profile-settings-card rounded-0">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <form v-on:submit="submit">
        <div class="row">
          <!-- ANAGRAPH -->
          <div class="col-12">
            <h4 class="mb-15 mb-sm-20 mb-md-25">{{ $t('form.section.user_information') }}</h4>
          </div>
          <!-- ROLE -->
          <div class="col-md-6" v-if="!role?.is_custom_role && role_id_param === undefined">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.role.label') }}*
              </label>
              <div>
                <select class="form-select shadow-none text-black fs-md-15" v-model="user.role_id" required
                  :disabled="update" :class="[{ 'is-invalid': submitted && errors?.role_id }]">
                  <option v-for="role in available_roles" :value="role.id" :key="role.id">{{ role.name }}</option>
                </select>
                <!-- ERRORS -->
                <div class="form-messages mt-2 px-1" v-if="errors?.role_id ?? false">
                  <p v-for="error in errors.role_id" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                    error }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- ROLE_IN_DEPARTMENT -->
          <div class="col-md-6" v-if="is_hcp">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('form.role_in_department.label') }}
              </label>
              <input v-model="user.role_in_department" class="form-control shadow-none text-black"
                :class="[{ 'is-invalid': submitted && errors?.role_id }]" />
              <!-- ERRORS -->
              <div class="form-messages mt-2 px-1" v-if="errors?.role_in_department ?? false">
                <p v-for="error in errors.role_in_department" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                  error }}</p>
              </div>
            </div>
          </div>
          <div class="col-12"></div>

          <template v-if="!is_patient">
            <!-- FIRST NAME -->
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  {{ $t('form.first_name.label') }}*
                </label>
                <input v-model="user.firstname" type="text" class="form-control shadow-none text-black"
                  :required="!is_patient" :placeholder="$t('form.first_name.placeholder')"
                  :class="[{ 'is-invalid': submitted && errors?.firstname }]" />
                <!-- ERRORS -->
                <div class="form-messages mt-2 px-1" v-if="errors?.firstname ?? false">
                  <p v-for="error in errors.firstname" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                    error }}</p>
                </div>
              </div>
            </div>
            <!-- LAST NAME -->
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  {{ $t('form.last_name.label') }}*
                </label>
                <input v-model="user.lastname" type="text" class="form-control shadow-none text-black"
                  :class="[{ 'is-invalid': submitted && errors?.lastname }]" :required="!is_patient"
                  :placeholder="$t('form.last_name.placeholder')" />
                <!-- ERRORS -->
                <div class="form-messages mt-2 px-1" v-if="errors?.lastname ?? false">
                  <p v-for="error in errors.lastname" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                    error }}</p>
                </div>
              </div>
            </div>
          </template>

          <!-- CONTACTS -->
          <div class="col-12">
            <h4 class="mb-15 mb-sm-20 mb-md-25">{{ $t('form.section.contacts') }}</h4>
          </div>
          <!-- UPDATE (DISABLED) -->
          <template v-if="update">
            <!-- EMAIL -->
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  {{ $t('form.email.label') }}*
                </label>
                <input v-model="user.email" type="email" class="form-control shadow-none text-black" required
                  pattern="[^@\s]+@[^@\s]+\.[^@\s]+" :placeholder="$t('form.email.placeholder')" disabled />
                <!-- ERRORS -->
                <div class="form-messages mt-2 px-1" v-if="errors?.email ?? false">
                  <p v-for="error in errors.email" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                    error }}</p>
                </div>
              </div>
            </div>
            <!-- PHONE -->
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  {{ $t('form.phone.label') }}
                </label>
                <input v-model="user.phone_number" type="text" class="form-control shadow-none text-black"
                  :class="[{ 'is-invalid': submitted && errors?.phone_number }]"
                  :placeholder="$t('form.phone.placeholder')" />
                <!-- ERRORS -->
                <div class="form-messages mt-2 px-1" v-if="errors?.phine_number ?? false">
                  <p v-for="error in errors.phone_number" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                    error }}</p>
                </div>
              </div>
            </div>
          </template>
          <!-- CREATE -->
          <template v-else>
            <!-- EMAIL -->
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  {{ $t('form.email.label') }}*
                </label>
                <input v-model="user.email" type="email" class="form-control shadow-none text-black" required
                  pattern="[^@\s]+@[^@\s]+\.[^@\s]+" :placeholder="$t('form.email.placeholder')"
                  :class="[{ 'is-invalid': submitted && errors?.email }]" />
                <!-- ERRORS -->
                <div class="form-messages mt-2 px-1" v-if="errors?.email ?? false">
                  <p v-for="error in errors.email" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                    error }}</p>
                </div>
              </div>
            </div>
            <!-- PHONE -->
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  {{ $t('form.phone.label') }}
                </label>
                <input v-model="user.phone_number" type="text" class="form-control shadow-none text-black"
                  :class="[{ 'is-invalid': submitted && errors?.phone_number }]"
                  :placeholder="$t('form.phone.placeholder')" />
                <!-- ERRORS -->
                <div class="form-messages mt-2 px-1" v-if="errors?.phone_number ?? false">
                  <p v-for="error in errors.phone_number" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                    error }}</p>
                </div>
              </div>
            </div>
          </template>

          <div class="col-12" v-if="loading">
            <SpinnerLoading />
          </div>
          <div class="col-md-12" v-else>
            <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
              <!-- DELETE -->
              <button v-if="update" type="button" class="bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                data-bs-toggle="modal" data-bs-target="#confirmModal">
                <i class="ph ph-trash lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative">{{ $t('cta.delete_user') }}</span>
              </button>
              <span v-else></span>
              <!-- SAVE -->
              <div class="d-flex flex-wrap gap-3 justify-content-end ms-auto">
                <DiscardButton @confirm="$router.push({
                  path: update ? center_id != null ? `/center/${center_id}` : `/user/${user.id}` : '/system-users', query: {
                    center_id: center_id
                  }
                })" />
                <button
                  class="default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
                  type="submit" v-on:click="submitted = true">
                  {{ $t('cta.save_user') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- ERROR MESSAGE -->
  <div class="row justify-content-center">
    <div class="col">
      <div
        class="alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25"
        role="alert" id="errorMessage">
        <strong>{{ $t('error.something_went_wrong') }}</strong>
        <button type="button" class="btn-close" v-on:click="hideError" aria-label="Close"></button>
      </div>
    </div>
  </div>
  <ConfirmModal @confirm="deleteUser()" :title="$t('cta.$delete.title')" :message="$t('cta.$delete.message')" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DiscardButton from "@/components/Widgets/DiscardButton.vue";
import ConfirmModal from "@/components/Widgets/ConfirmModal.vue";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import { CreateUserInfo, Role, RoleInfo, UserInfo } from "@/utils/models/user.model";
import { removeNullProperties } from "@/utils/methods/remove_null_properties";
import API from "@/services/api/api.service";
import stateStore from "@/utils/store";

export default defineComponent({
  name: "UserForm",
  components: {
    ConfirmModal,
    SpinnerLoading,
    DiscardButton,
  },
  data: function () {
    return {
      user: {
        role_id: this.$route.query?.role_id !== undefined ? parseInt(this.$route.query?.role_id as string) : undefined
      } as CreateUserInfo,
      submitted: false,
      roles: (this.$route.meta.roles as RoleInfo[]) ?? [],
      loading: false,
      errors: undefined as any,
      center_id: this.$route.query?.center_id as string | undefined,
      role: undefined as RoleInfo | undefined,
    }
  },
  mounted() {
    var userInfo = this.$route.meta.user as UserInfo | undefined;
    if (userInfo != undefined) {
      this.user = {
        id: userInfo.id,
        email: userInfo.email,
        firstname: userInfo.firstname,
        lastname: userInfo.lastname,
        phone_number: userInfo.phone_number,
        role_id: userInfo.role.id,
        role_in_department: userInfo.role_in_department != '' ? userInfo.role_in_department : undefined,
      }
      this.role = userInfo.role;
    }
    /* API.getRoles().then((response) => {
      this.roles = (response.data.data as RoleInfo[] | undefined)?.filter((role) => role.type != Role.patient && role.type != Role.caregiver);
      console.log(this.roles);
    }) */
  },
  computed: {
    role_id_param(): number | undefined { return this.$route.query?.role_id !== undefined ? parseInt(this.$route.query?.role_id as string) : undefined; },
    update() {
      return this.$route.meta.user !== undefined && this.$route.meta.user !== null;
    },
    available_roles(): RoleInfo[] {
      let roles = [] as RoleInfo[];
      stateStore.user?.info.role.type == Role.admin
      if(stateStore.user?.info.role.type == Role.admin) {
        roles = (this.roles ?? []).filter((role) => role.type == Role.admin || role.type == Role.internal) ?? [];
      } else {
        roles = (this.roles ?? []).filter((role) => role.type == Role.hcp) ?? [];
      }

      return roles;
    },
    role_info(): RoleInfo | undefined {
      return this.roles?.find((role) => role.id == this.user.role_id);
    },
    is_patient(): boolean {
      return this.role_info?.type == Role.patient;
    },
    is_caregiver(): boolean {
      return this.role_info?.type == Role.caregiver;
    },
    is_admin(): boolean {
      return this.role_info?.type == Role.admin;
    },
    is_hcp(): boolean {
      return this.role_info?.type == Role.hcp || this.role_info?.type == Role.internal;
    },
    
  },
  methods: {
    submit(event): void {
      this.errors = undefined;
      event.preventDefault();

      if (this.is_patient) {
        this.user.firstname = undefined;
        this.user.lastname = undefined;
      }
      removeNullProperties<UserInfo>(this.user);

      this.loading = true;
      if (this.update) {
        console.log('UPDATE');
        API.updateUser((this.user as UserInfo)).then((response) => {
          if (this.center_id != undefined) {
            this.$router.push(`/center/${this.center_id}`)
          } else {
            this.$router.push(`/user/${response.data.data.id}`);
          }
        }).catch((error) => {
          this.errors = error.response?.data?.errors;
          this.showError();
        }).finally(() => {
          this.loading = false;
        });
      } else {
        console.log('CREATE');
        //this.patient.email = this.patient.users![0].email;
        // this.patient.phone_number = this.patient.users![0].phone_number;

        API.createUser(this.user as CreateUserInfo).then((response) => {
          if (this.center_id != undefined) {
            this.$router.push(`/center/${this.center_id}`)
          } else {
            this.$router.push(`/user/${response.data.data.id}`);
          }
        }).catch((error) => {
          this.errors = error.response?.data?.errors;
          this.showError();
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    deleteUser(): void {
      this.loading = true;
      API.deleteUser((this.user as UserInfo).id!).then((response) => {
        if (response.data.success === true) {
          if (this.is_hcp) {
            this.$router.push(`/system-centers`)
          } else {
            this.$router.push('/system-users');
          }
        }
      }).catch((error) => {
        this.showError();
      }).finally(() => {
        console.log("DELETED_USER_ID", (this.user as UserInfo).id);
        this.loading = false;
      })
    },
    showError() {
      const error = document.getElementById('errorMessage');
      error?.classList.add('show');
      setTimeout(() => {
        this.hideError();
      }, 5000)
    },
    hideError() {
      const error = document.getElementById('errorMessage');
      error?.classList.remove('show');
    }
  },
});
</script>